export default __webpack_public_path__ + "static/media/people.ff09ede3.svg";